import { render, staticRenderFns } from "./conversation-page.vue?vue&type=template&id=78421550&scoped=true&"
import script from "./conversation-page.vue?vue&type=script&lang=js&"
export * from "./conversation-page.vue?vue&type=script&lang=js&"
import style0 from "./conversation-page.vue?vue&type=style&index=0&id=78421550&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78421550",
  null
  
)

export default component.exports